// extracted by mini-css-extract-plugin
module.exports = {"tabs":"cd01fbf7b5--tabs--HYriS","tab":"cd01fbf7b5--tab--gaAk0","title":"cd01fbf7b5--title--P3dTI"};